module.exports = __webpack_public_path__ + "img/bg_app_view.200f638a.svg";